export default __webpack_public_path__ + "static/media/logo-vedi-blanco-nuevo.c8600b24.png";